import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class CarrierInformationService {
	isEditMode: boolean = false;
	isRecalculating: boolean = false;
	isCovModCarrierSeen: boolean = false;

	constructor() {
		var carrierInformation: any = {
			isEditMode: false,
			isRecalculating: false,
			isCovModCarrierSeen: false,
		};

		sessionStorage.setItem('CarrierInformation', JSON.stringify(carrierInformation));
	}

	setEditMode(value: boolean) {
		const sessionStorageData = JSON.parse(sessionStorage.getItem('CarrierInformation'));

		sessionStorageData.isEditMode = value;

		sessionStorage.setItem('CarrierInformation', JSON.stringify(sessionStorageData));

		this.isEditMode = value;
	}

	setIsRecalculating(value: boolean) {
		const sessionStorageData = JSON.parse(sessionStorage.getItem('CarrierInformation'));

		sessionStorageData.isRecalculating = value;

		sessionStorage.setItem('CarrierInformation', JSON.stringify(sessionStorageData));

		this.isRecalculating = value;
	}

	setIsCovModCarrierSeen(value: boolean) {
		const sessionStorageData = JSON.parse(sessionStorage.getItem('CarrierInformation'));

		sessionStorageData.isCovModCarrierSeen = value;

		sessionStorage.setItem('CarrierInformation', JSON.stringify(sessionStorageData));

		this.isCovModCarrierSeen = value;
	}
}
